/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DeploymentPodsResponse = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        desired_replicas: {
            type: 'number',
            isRequired: true,
        },
        current_replicas: {
            type: 'number',
            isRequired: true,
        },
        available_replicas: {
            type: 'number',
            isRequired: true,
        },
        pods: {
            type: 'array',
            contains: {
                type: 'PodInfo',
            },
        },
    },
} as const;
